"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentTypeInfoMap = {
    "application/pdf": {
        name: "fileTypes.pdf",
        category: "fileTypes.pdf",
        defaultMessage: "PDF",
    },
    "application/javascript": {
        name: "fileTypes.js",
        category: "fileTypes.js",
        defaultMessage: "JavaScript",
    },
    "application/vnd.ms-excel": {
        name: "fileTypes.msExcel",
        category: "fileTypes.excel",
        defaultMessage: "Excel",
    },
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
        name: "fileTypes.msExcel",
        category: "fileTypes.excel",
        defaultMessage: "Excel",
    },
    "text/csv": {
        name: "fileTypes.comma_seperated_values",
        category: "fileTypes.csv",
        defaultMessage: "Comma Separated Values (CSV)",
    },
    "application/vnd.ms-powerpoint": {
        name: "fileTypes.msPowerpoint",
        category: "fileTypes.powerpoint",
        defaultMessage: "Powerpoint",
    },
    "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
        name: "fileTypes.msPowerpoint",
        category: "fileTypes.powerpoint",
        defaultMessage: "Powerpoint",
    },
    "application/msword": {
        name: "fileTypes.msWord",
        category: "fileTypes.word",
        defaultMessage: "Word",
    },
    "application/vnd.ms-word": {
        name: "fileTypes.msWord",
        category: "fileTypes.word",
        defaultMessage: "Word",
    },
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
        name: "fileTypes.msWord",
        category: "fileTypes.word",
        defaultMessage: "Word",
    },
    "application/quartz": {
        name: "fileTypes.quartz",
        category: "fileTypes.quartz",
        defaultMessage: "Document",
    },
    "image/gif": {
        name: "fileTypes.gifImage",
        category: "fileTypes.image",
        defaultMessage: "GIF Image",
    },
    "image/jpeg": {
        name: "fileTypes.JPEGImage",
        category: "fileTypes.image",
        defaultMessage: "JPEG Image",
    },
    "image/png": {
        name: "fileTypes.PNGImage",
        category: "fileTypes.image",
        defaultMessage: "PNG Image",
    },
    "image/tiff": {
        name: "fileTypes.TIFFImage",
        category: "fileTypes.image",
        defaultMessage: "TIFF Image",
    },
    "image/bmp": {
        name: "fileTypes.BMPImage",
        category: "fileTypes.image",
        defaultMessage: "BMP Image",
    },
    "text/html": {
        name: "fileTypes.HTML",
        category: "fileTypes.text",
        defaultMessage: "HTML",
    },
    "text/plain": {
        name: "fileTypes.text",
        category: "fileTypes.text",
        defaultMessage: "Text",
    },
};
var mimeTypes = Object.keys(exports.contentTypeInfoMap);
var messageMap = {
    file: {
        id: "fileTypes.file",
        defaultMessage: "File",
    },
};
mimeTypes.forEach(function (mimeType) {
    var nameCategory = exports.contentTypeInfoMap[mimeType];
    messageMap[nameCategory.name] = {
        id: nameCategory.name,
        defaultMessage: nameCategory.defaultMessage,
    };
});
/**
 * Converts MIME type to human readable string
 *
 * @param mimeType
 * @param intl
 */
function getReadableFileType(mimeType, intl) {
    var contentTypeInfo = exports.contentTypeInfoMap[mimeType];
    return contentTypeInfo
        ? intl.formatMessage(messageMap[contentTypeInfo.name])
        : intl.formatMessage(messageMap.file);
}
exports.getReadableFileType = getReadableFileType;
function getReadableSize(sizeInBytes, language) {
    if (sizeInBytes === undefined || sizeInBytes === null || sizeInBytes < 0) {
        return "--";
    }
    if (sizeInBytes === 0) {
        return "0 B";
    }
    var prefixes = " KMGTPEZYXWVU";
    var prefixIndex = Math.min(Math.floor(Math.log(sizeInBytes) / Math.log(1024)), 12);
    return (Math.round((sizeInBytes * 100) / Math.pow(1024, prefixIndex)) / 100 +
        " " +
        prefixes.charAt(prefixIndex).replace(" ", "") +
        (language === "fr" && prefixIndex > 0 ? "o" : "B"));
}
exports.getReadableSize = getReadableSize;
